import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import SocialProofSection from './components/SocialProofSection';
import BenefitsSection from './components/BenefitsSection';
import ProcessSection from './components/ProcessSection';
import CTASection from './components/CTASection';
import LeadMagnetModal from './components/LeadMagnetModal';

const HomePage = () => {
  const [showLeadMagnet, setShowLeadMagnet] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <SocialProofSection />
        <BenefitsSection onDownloadClick={() => setShowLeadMagnet(true)} />
        <ProcessSection />
        <CTASection />
      </main>
      <Footer />
      {showLeadMagnet && (
        <LeadMagnetModal onClose={() => setShowLeadMagnet(false)} />
      )}
    </div>
  );
};

export default HomePage;
